const getPrepareEsignModalProps = (docProps) => {
    return {
        document: {...docProps},
        toggleModal: jest.fn(),
        prepareEsign: jest.fn(),
        guarantors: [
            {
                archivedDocuments: [],
                business: { rid: 5432 },
                documents: [{...docProps}],
                email: null,
                fiscal_years: [],
                name: "People Person",
                orderId: 1235456,
                rid: 456,
                spouseId: null,
                taxAddress: null,
                taxReturnUrls: [],
                taxReturns: [],
                useBusinessTaxReturn: false
            }
        ],
        helloSign: {
            helloSign: {
                clientId: "123456789",
                testMode: true
            },
            loading: false,
            networkStatus: 7,
            loanId: 123456
        },
        state: {
            complete: false,
            documentType: "template",
            file: "",
            requestMethod: null,
            signers: [
                {
                    name: "People Person",
                    email: "people@temp.com",
                    role: "",
                }
            ]
        }
    }
}
export default getPrepareEsignModalProps;